export default "__VITE_ASSET__CuuVZhXN__"